import { lazy } from 'react';

const DespachosPendientesLayout = lazy(() =>
    import('../../despachos-pendientes/DespachosPendientesLayout.jsx')
);
const DespachosPendientes = lazy(() =>
    import('../../despachos-pendientes/DespachosPendientes.jsx')
);

const despachosPendientesRoutes = [
    {
        path: 'stock/despachos-pendientes',
        element: <DespachosPendientesLayout />,
        children: [
            { index: true, element: <DespachosPendientes /> },
        ],
    },
];

export default despachosPendientesRoutes;
